import { siteConfig } from "../../config/siteConfig";

export const About = () => {
    return (
        <section
            id="sobre"
            data-testid="about-section"
            className="py-24 border-b border-[#1e2430] bg-[#0c1017]"
        >
            <div className="max-w-6xl mx-auto px-6">
                <div className="grid md:grid-cols-12 gap-12 items-center">
                    <div className="md:col-span-5">
                        <div className="h-80 rounded-2xl overflow-hidden relative border border-[#222e42]">
                            <img
                                src="https://images.unsplash.com/photo-1590212151175-e58edd96185b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwd29ya3N0YXRpb24lMjBtb25pdG9yJTIwYW1iaWVudCUyMGJsdWUlMjBsaWdodCUyMGRhcmt8ZW58MHx8fHwxNzkxOTQ5MDQyfDA&ixlib=rb-4.1.0&q=85"
                                alt="Estação de trabalho minimalista com luz ambiente azul"
                                className="absolute inset-0 w-full h-full object-cover"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 p-6 flex flex-col justify-end bg-gradient-to-t from-black/80 via-black/20 to-transparent">
                                <span className="code-font text-xs text-blue-400 uppercase tracking-widest block mb-1">
                                    Linkora Studio
                                </span>
                                <span className="text-sm font-semibold text-white">
                                    {siteConfig.domain}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-7">
                        <span className="code-font text-xs text-[#2563eb] uppercase tracking-wider block mb-2">
                            04 / Sobre Nós
                        </span>
                        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-6">
                            Tecnologia com propósito. Design com estratégia.
                        </h2>
                        <div className="space-y-4 text-slate-300 text-sm md:text-base leading-relaxed">
                            <p>
                                A Linkora nasceu com a proposta de ajudar empresas e profissionais
                                a fortalecer sua presença digital por meio de sites modernos,
                                funcionais e alinhados aos objetivos de cada negócio.
                            </p>
                            <p>
                                Unimos criatividade, tecnologia e atenção aos detalhes para
                                desenvolver experiências digitais que valorizam cada marca.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
